"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetMapData = void 0;
/**
 * Stores data used to load and unload assets.
 */
var AssetMapData = /** @class */ (function () {
    /**
     * @deprecated use asset classes from Load/Assets package
     * @param pAssetName
     * @param pAssetType
     */
    function AssetMapData(pAssetName, pAssetType) {
        /**
         * Path to the asset
         */
        this.assetPath = "";
        /**
         * If resolution suffix is set the asset is loaded only on devices with the matched asset resolution
         */
        this.resolutionSuffix = "";
        this.assetName = pAssetName;
        this.assetType = pAssetType;
    }
    AssetMapData.prototype.getResource = function () {
        var resource = PIXI.Loader.shared.resources[this.assetName];
        if (!resource) {
            throw new Error("Asset " + this.assetName + " is not loaded.");
        }
        return resource;
    };
    AssetMapData.prototype.getLoaderOptions = function () {
        return undefined;
    };
    AssetMapData.prototype.isLoaded = function () {
        return !!PIXI.Loader.shared.resources[this.assetName];
    };
    AssetMapData.prototype.destroy = function () {
        // Additional actions required to destroy the asset
    };
    return AssetMapData;
}());
exports.AssetMapData = AssetMapData;
//# sourceMappingURL=AssetMapData.js.map